var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatacenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "24px",
    viewBox: "0 0 30 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dc icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Purchase-\\u2013-order",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purchase-order-add-to-cart",
    transform: "translate(-364.000000, -289.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dc-icon",
    transform: "translate(365.000000, 290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-Copy",
    transform: "translate(0.059814, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,18.2764337 C0,18.8816136 0.508003374,19.3657575 1.14300759,19.3657575 L12.7000843,19.3657575 C13.3350886,19.3657575 13.8430919,18.8816136 13.8430919,18.2764337 L13.8430919,0 L0,0 L0,18.2764337 L0,18.2764337 Z",
    id: "Shape",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17502108,3.63107954 L10.7950717,3.63107954",
    id: "Shape",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17502108,13.3139583 L10.7950717,13.3139583",
    id: "Shape",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17502108,16.3398579 L10.7950717,16.3398579",
    id: "Shape",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#003366",
    cx: 6.98504639,
    cy: 8.83562687,
    rx: 1.01600675,
    ry: 0.968287877
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-Copy",
    transform: "translate(14.029907, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,18.2764337 C0,18.8816136 0.508003374,19.3657575 1.14300759,19.3657575 L12.7000843,19.3657575 C13.3350886,19.3657575 13.8430919,18.8816136 13.8430919,18.2764337 L13.8430919,0 L0,0 L0,18.2764337 L0,18.2764337 Z",
    id: "Shape",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17502108,3.63107954 L10.7950717,3.63107954",
    id: "Shape",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17502108,13.3139583 L10.7950717,13.3139583",
    id: "Shape",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17502108,16.3398579 L10.7950717,16.3398579",
    id: "Shape",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#003366",
    cx: 6.98504639,
    cy: 8.83562687,
    rx: 1.01600675,
    ry: 0.968287877
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    fill: "#FFFFFF",
    x: 7,
    y: 2,
    width: 14,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(7.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,18.875 C0,19.5 0.509090909,20 1.14545455,20 L12.7272727,20 C13.3636364,20 13.8727273,19.5 13.8727273,18.875 L13.8727273,0 L0,0 L0,18.875 L0,18.875 Z",
    id: "Shape",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18181818,3.75 L10.8181818,3.75",
    id: "Shape",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18181818,13.75 L10.8181818,13.75",
    id: "Shape",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18181818,16.875 L10.8181818,16.875",
    id: "Shape",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#003366",
    cx: 7,
    cy: 9.125,
    rx: 1.01818182,
    ry: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatacenter);
export default __webpack_public_path__ + "static/media/datacenter.4958a2b2931a309c6f36f52736ff4111.svg";
export { ForwardRef as ReactComponent };